import type { SubscribeCallbacks } from '@exchange/libs/utils/wss/src';
import { MarketsChannelTemplate } from '@exchange/libs/utils/wss/src/lib/templates/Market.channel.template';

import type { BookTickMessage } from './book-ticker-model';

interface BookTickerChannelConfig {
  markets: string[];
  onMessage: (message: BookTickMessage) => void;
}

class BookTickerChannel extends MarketsChannelTemplate<BookTickMessage> {
  protected readonly channelName = 'BOOK_TICKER';

  static subscribe(config: BookTickerChannelConfig, callbacks?: SubscribeCallbacks) {
    return this.getInstance().subscribeToMarkets(config, callbacks);
  }

  private static instance: BookTickerChannel;

  private static getInstance() {
    if (!this.instance) {
      this.instance = new BookTickerChannel();
    }
    return this.instance;
  }

  private subscribeToMarkets(config: BookTickerChannelConfig, callbacks?: SubscribeCallbacks) {
    const subscriptions = config.markets.map((market) =>
      this.subscribe(
        {
          market,
          onMessage: config.onMessage,
        },
        callbacks,
      ),
    );

    return async () => {
      await Promise.all(subscriptions.map((unsub) => unsub()));
    };
  }
}

export default BookTickerChannel;
